import { IServer, IServiceInstance } from '@module/license/models';
import { SITE_API_URI } from '@service/constants';
import SiteApiClient from '@service/siteApiClient';

const client = new SiteApiClient(SITE_API_URI);

export function requestServerGet(siteId: number, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            const req = client.getAllServers(siteId, accessToken);
            req.then((data: any) => {
                const server = data.allowances.map(toServer);
                const services = data.availableServices;
                resolve({ server, services });
            }).catch((err: any) => reject(err));
        }
    );
}

export function requestOperationalUsageGet(accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            const req = client.getOperationalUsages(accessToken);
            req.then((data: any) => {
                resolve(toOperationalUsage(data));
            }).catch((err: any) => reject(err));
        }
    );
}

function toOperationalUsage(it: any) {
    const OperationalUsages: any[] = [];
    it.forEach((instance: any) => {
        OperationalUsages.push(
            {
                id: instance.id,
                usageName: instance.usageName,
                label: instance.usageName
            }
        );
    });
    return OperationalUsages;
}

function toServiceInstance(it: any) {
    const ServiceInstances: IServiceInstance[] = [];
    it.forEach((instance: any) => {
        ServiceInstances.push(
            {
                id: instance.id,
                serverId: instance.serverId,
                siteId: instance.siteId,
                selectedServiceType: instance.selectedService,
                serviceList: instance.availableServices,
                allocatedAssets: { value: instance.allocatedAssets, valid: true },
                assetType: instance.selectedService.assetType.assetTypeName,
                isBeingEdited: false,
                discriminator: ''
            }
        );
    });
    return ServiceInstances;
}

export function requestServerPost(server: IServer, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.addServer(server, accessToken).then(r => r.json()).then(data => {
                resolve(toServerResponse(data));
            }).catch((err: any) => reject(err));
        }
    );
}

export function requestServerPut(server: IServer, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.updateServer(server, accessToken)
            .then((response: any) => {
                if (response.ok) {
                    resolve(response);
                } else {
                    reject(new Error(response.statusText));
                }
            })
            .catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestServerDelete(server: IServer, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.deleteServer(server, accessToken).then(r => {
                resolve(server);
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

function toServer(it: any) {
    return {
        id: it.server.id,
        description: { value: it.server.serverName, valid: true },
        serverId: { value: it.server.hardwareId, valid: true },
        operationalUseType: it.server.selectedOperationalUsage,
        isBeingEdited: false,
        siteId: it.server.siteId,
        serviceAllocations: toServiceInstance(it.allowances),
        isAvailable: false
    };
}

function toServerResponse(data: any) {
    const serverResponse: IServer = {
        description: { value: data.serverName, valid: true },
        id: data.id,
        siteId: data.siteId,
        serverId: { value: data.hardwareId, valid: true },
        isBeingEdited: false,
        operationalUseType: data.selectedOperationalUsage,
        serviceAllocations: [],
        discriminator: '',
        isAvailable: false
    };
    return serverResponse;
}
